module.exports = __webpack_public_path__ + "static/media/windmill.58a99299.svg";